import styled from 'styled-components';

/**
 * Wrapper per le pagine del pannello Admin.
 * Tema: bordeaux/rosso — sfondo freddo scuro, striscia superiore bordeaux.
 */
const AdminWrapper = styled.div`
  height: 100%;
  min-height: calc(100vh - 70px);
  width: 100%;
  overflow-y: auto;
  background-color: rgb(22, 18, 18);
  border-top: 3px solid rgb(163, 27, 27);
`;

export default AdminWrapper;
